import { getDataGridToolbarProps } from '../../../../utility/dataGridToolbarHelper';

export const EMPTY_COLUMNS = [];
export const EMPTY_MODEL = {};

export const GRID_MODE = {
  CLIENT: 'client',
  SERVER: 'server',
};

export const DEFAULT_TOOLBAR = getDataGridToolbarProps();

export const DEFAULT_SEARCH = {
  placeholder: 'Search...',
};

export const DEFAULT_PAGINATION = {
  enabled: true,
  pageSize: 25,
  rowsPerPageOptions: [10, 25, 50, 100],
};

export const DEFAULT_INITIAL_PINNED_COLUMNS = {
  left: [],
  right: [],
};

export const DEFAULT_PERSIST_GRID_STATE = {
  pageSize: false,
  density: false,
  columnVisibility: false,
  columnWidths: false,
  sortModel: false,
  searchText: false,
  columnSearch: false,
  filters: false,
  pinnedColumns: false,
  columnOrder: false,
};

export const DEFAULT_SERVER_SIDE = {
  totalRecords: 0,
  onStateChange: null,
};

export const DEFAULT_GET_ROW_CLASS_NAME = () => '';

export const DEFAULT_ACTIONS = {
  edit: {
    visible: false,
    onClick: null,
    disabled: false,
  },
  delete: {
    visible: false,
    onClick: null,
    disabled: false,
  },
  custom: [],
};

export const DEFAULT_LAYOUT_SYNC = {
  enabled: false,
  gridKey: null,
};

export const GRID_PERSIST_KEYS = {
  PAGE_SIZE: 'pageSize',
  DENSITY: 'density',
  COLUMN_VISIBILITY: 'columnVisibility',
  COLUMN_WIDTHS: 'columnwidths',
  SORT_MODEL: 'sortModel',
  FILTERS: 'filters',
  SEARCH_TEXT: 'searchText',
  COLUMN_SEARCH: 'columnSearch',
  PINNED_COLUMNS: 'pinnedColumns',
  COLUMN_ORDER: 'columnOrder',
};
